module.exports = __webpack_public_path__ + "img/1_2-parcheggio-0.38d66606.png";